import { VENDOR_USERS_FETCHING,
  VENDOR_USERS_FAILED,
  VENDOR_USERS_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case VENDOR_USERS_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case VENDOR_USERS_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case VENDOR_USERS_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
